import React, { useState } from "react";

import "./filter-modal.style.scss";

const FilterModal = ({
	categories = [],
	filters = null,
	dismiss = () => {},
	onClear = () => {},
	onFilter = () => {},
}) => {
	const [localFilters, setLocalFilters] = useState(
		filters ?? {
			clientType: [], // for Client Type
			subscription: [], // for Subscription
			archivePeriod: [], // for Archive Period
			safeLockingPeriod: [], // for Safe Locking PeriodSafe Locking Period
			liveChat: [], // for Live Chat
			mobile: [], // for Mobile App
		}
	);

	const handleSubmit = () => {
		onFilter(localFilters);
		dismiss();
	};

	const handleClear = () => {
		onClear();
		dismiss();
	};

	const handleChange = ({ category, choice }) => {
		setLocalFilters((oldValue) => {
			const newValue = { ...oldValue };
			const index = newValue[category].indexOf(choice);
			if (index === -1) {
				// choice is not already selected
				newValue[category].push(choice);
			} else {
				newValue[category].splice(index, 1);
			}
			return newValue;
		});
	};
	return (
		<div className="filter-modal-container absolute fill">
			<div onClick={dismiss} className="absolute fill" />
			<div className="modal absolute smooth-corners padding-m--inline padding-m--bottom">
				{categories.slice(0, 4).map(({ key, label, choices }, categoryIndex) => {
					return (
						<div
							key={categoryIndex}
							className="border--bottom padding-s--bottom padding-m--top filter-instance-wrapper"
						>
							<p className="size300 w600 padding-s--bottom">{label}</p>
							<div className="flex gap-s size300 w400">
								{choices.map((choice, choiceIndex) => {
									const isSelected =
										Object.values(localFilters)[categoryIndex].indexOf(choiceIndex) !== -1;
									return (
										<div
											key={choiceIndex}
											onClick={() => {
												handleChange({
													category: key,
													choice: choiceIndex,
												});
											}}
											className={`pointer ${isSelected && "selected"}`}
										>
											{choice}
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
				<div className="flex gap-xxl">
					{categories.slice(4).map(({ key, label, choices }, categoryIndex) => {
						return (
							<div
								key={label}
								className="flex--grow border--bottom padding-s--bottom padding-m--top filter-instance-wrapper"
							>
								<p className="size300 w600 padding-s--bottom">{label}</p>
								<div className="flex gap-s size300 w400">
									{choices.map((choice, choiceIndex) => {
										const isSelected =
											Object.values(localFilters)[categoryIndex + 4].indexOf(choiceIndex) !== -1;
										return (
											<div
												key={choiceIndex}
												onClick={() => {
													handleChange({
														category: key,
														choice: choiceIndex,
													});
												}}
												className={`pointer ${isSelected && "selected"}`}
											>
												{choice}
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
				<div className="flex gap-l margin-l--top">
					<button
						onClick={handleClear}
						className="w500 size300 smooth-corners padding-s--block clear"
					>
						Clear All
					</button>
					<button
						onClick={handleSubmit}
						className="w500 size300 smooth-corners padding-s--block filter"
					>
						Filter
					</button>
				</div>
			</div>
		</div>
	);
};

export default FilterModal;
